import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'DOP') {
  const symbol = currency === 'DOP' ? 'RD$' : 'US$';
  return `${symbol} ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  // Si es solo fecha (YYYY-MM-DD), agregar T12:00:00 para evitar problemas de timezone
  let date;
  if (dateString.length === 10) {
    // Solo fecha, sin hora - usar mediodía para evitar cambio de día
    date = new Date(dateString + 'T12:00:00');
  } else {
    date = new Date(dateString);
  }
  return date.toLocaleDateString('es-DO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('es-DO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStatusColor(status) {
  switch (status) {
    case 'pagado':
      return 'bg-green-100 text-green-800';
    case 'pendiente':
      return 'bg-yellow-100 text-yellow-800';
    case 'credito':
      return 'bg-blue-100 text-blue-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

export function getStatusLabel(status) {
  switch (status) {
    case 'pagado':
      return 'Pagado';
    case 'pendiente':
      return 'Pendiente';
    case 'credito':
      return 'Crédito';
    default:
      return status;
  }
}

// Unit conversion helpers
export const UNIT_CONVERSIONS = {
  qq_to_lb: 100,
  qq_to_kg: 45.36,
  lb_to_kg: 0.4536,
  kg_to_lb: 2.205,
  kg_to_qq: 0.022,
  lb_to_qq: 0.01,
};

export function convertUnit(value, fromUnit, toUnit) {
  if (fromUnit === toUnit) return value;
  
  const key = `${fromUnit}_to_${toUnit}`;
  const factor = UNIT_CONVERSIONS[key];
  
  if (factor) {
    return value * factor;
  }
  
  // Try reverse conversion
  const reverseKey = `${toUnit}_to_${fromUnit}`;
  const reverseFactor = UNIT_CONVERSIONS[reverseKey];
  
  if (reverseFactor) {
    return value / reverseFactor;
  }
  
  return value;
}

// Format stock: remove unnecessary decimals (10.0000 -> 10, 10.5000 -> 10.5, 10.5500 -> 10.55)
// Now includes thousand separators
export function formatStock(value, unit = '') {
  if (value === null || value === undefined) return '0';
  
  const num = parseFloat(value);
  
  // If it's a whole number, show without decimals but with thousand separators
  if (Number.isInteger(num)) {
    const formatted = num.toLocaleString('en-US');
    return unit ? `${formatted} ${unit}` : formatted;
  }
  
  // Otherwise, show with up to 2 decimals, removing trailing zeros, with thousand separators
  const formatted = num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  return unit ? `${formatted} ${unit}` : formatted;
}

// Format number with thousand separators (2000 -> 2,000)
export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined || isNaN(value)) return '0';
  
  const num = parseFloat(value);
  
  // If it's a whole number and decimals not required, show without decimals
  if (Number.isInteger(num) && decimals === 0) {
    return num.toLocaleString('en-US');
  }
  
  return num.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
